import script from "./bi-tmpl-add-dialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./bi-tmpl-add-dialog.vue?vue&type=script&lang=tsx&setup=true"

import "./bi-tmpl-add-dialog.vue?vue&type=style&index=0&id=4c7af174&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c7af174"]])

export default __exports__